<!-- Login Area Start -->
<div class="login_modal_cover" (click)="onCloseLogin()"></div>
<div class="loginOver" *ngIf="showLoginPopup">
  <div class="quicklogin-container">
    <div class="logo-section">
      <img class="content" src="../../../assets/siteImg/login_bgs.webp" alt="Login Banner" />
      <span class="logo-text">
        {{ 'AGE_TERMS_TEXT' | translate }}
        <strong (click)="onCloseLogin()" routerLink="/terms-and-conditions">
          {{ 'TERMS_CONDITIONS' | translate }}
        </strong>
      </span>

    </div>

    <div class="login-section m_t_10" [ngClass]="">
      <div class="button-section" *ngIf="FormOpenStr !== 'FORGOTPASSWORD'">
        <button type="button" class="register-btn" [class.active]="FormOpenStr === 'REGISTER'"
          (click)="onEnableLoginState('REGISTER')">
          {{'JOIN_US' | translate}}
        </button>
        <button type="button" class="login-btn" [class.active]="FormOpenStr === 'LOGIN'"
          (click)="onEnableLoginState('LOGIN')">
          {{'LOGIN' | translate }}
        </button>
      </div>
      <div class="exit-btn-container">
        <i class='fas fa-times' style='font-size:24px;color: #fff;' (click)="onCloseLogin()"></i>
      </div>
      <span *ngIf="FormOpenStr !== 'FORGOTPASSWORD'">
        <div *ngIf="errorMessage" class="alert alert-danger">
          {{ errorMessage | translate }}
        </div>
      </span>

      <div [ngClass]="googleSSO && FormOpenStr === 'REGISTER'?'form-section m_t_60': 'form-section'">


        <form #registerForm="ngForm" class="login-form m_t_10 register-form" *ngIf="FormOpenStr === 'REGISTER'"
          (ngSubmit)="onSubmitRegister(registerForm)">
          <!-- Username -->
          <label>
            <small class="remember-me"><span>{{'USERNAME' | translate}}* </span></small>

            <input name="username" [placeholder]="'ENTER_USERNAME' | translate" [(ngModel)]="register.username" required
              #username="ngModel" minlength="4" maxlength="15" pattern="^[a-zA-Z0-9]+$" aria-required="true"
              [disabled]="autoGenerateEnable" (keypress)="preventSpace($event)"
              (input)="registerForm.controls['username'].markAsTouched()" [ngClass]="{
                          'active-border':username?.touched && username?.invalid
                        }" />

            <div *ngIf="username?.touched && username?.invalid
                          " class="error">
              <small *ngIf="registerForm.controls['username']?.errors?.['required']">
                {{ 'USERNAME_REQUIRED' | translate }}
              </small>
              <small *ngIf="registerForm.controls['username']?.errors?.['minlength'] || 
                                        registerForm.controls['username']?.errors?.['maxlength']">
                {{ 'USERNAME_LENGTH' | translate }}
              </small>

              <small *ngIf="registerForm.controls['username']?.errors?.['pattern']">
                {{ 'USERNAME_PATTERN' | translate }}
              </small>
            </div>
          </label>

          <!-- Email -->
          <!-- <label>
            <small>{{"EMAIL" | translate}}*</small>
            <input name="email" type="email" #email="ngModel" [placeholder]="'ENTER_EMAIL' | translate"
              [ngStyle]="{ color: googleSSO ? 'white' : '' }" [disabled]="!!googleSSO" [(ngModel)]="register.email"
              required email (input)="registerForm.controls['email'].markAsTouched()" (keypress)="preventSpace($event)"
              [ngClass]="{
                                'active-border': email?.touched && email.invalid
                              }" />
            <div *ngIf="email?.touched && email.invalid" class="error">

              <small *ngIf="email.errors?.['required']">
                {{ 'EMAIL_REQUIRED' | translate }}
              </small>

              <small *ngIf="email.errors?.['email']">
                {{ 'EMAIL_INVALID' | translate }}
              </small>


            </div>


          </label> -->

          <!-- Password -->
          <label>
            <small class="remember-me"><span>{{'PASSWORD' | translate}}* </span>
            </small>
            <div class="password-wrapper">

              <input name="password" #password1="ngModel" [type]="showPassword ?  'text':'password'"
                [placeholder]="'ENTER_PASSWORD' | translate" [disabled]="autoGenerateEnable"
                [(ngModel)]="register.password" required minlength="6" maxlength="15" pattern="^[^\s]+$"
                (input)="registerForm.controls['password'].markAsTouched()" (keypress)="preventSpace($event)" [ngClass]="{
                                'active-border':
                                password1?.touched &&
                                password1.invalid
                              }" />
              <span class="toggle-eye" (click)="togglePassword()">
                <i [class]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
              </span>
            </div>
            <div *ngIf="
                            registerForm.controls['password']?.touched &&
                            registerForm.controls['password'].invalid
                          " class="error">
              <small *ngIf="registerForm.controls['password']?.errors?.['required']">
                {{ 'PASSWORD_REQUIRED' | translate }}
              </small>

              <small *ngIf="registerForm.controls['password']?.errors?.['minlength'] || 
                                            registerForm.controls['password']?.errors?.['maxlength']">
                {{ 'PASSWORD_LENGTH' | translate }}
              </small>

              <small *ngIf="registerForm.controls['password']?.errors?.['pattern']">
                {{ 'PASSWORD_NO_SPACES' | translate }}
              </small>
            </div>
          </label>


          <!-- Phone -->
          <label>
            <small>{{"PHONE" | translate}}*</small>
            <input name="phone" type="text" #phone="ngModel" [placeholder]="'PLEASE_ENTER_PHONE_NUMBER' | translate"
              [(ngModel)]="register.phone" maxlength="13" pattern="^[0-9]{1,13}$" required
              (input)="registerForm.controls['phone'].markAsTouched()" [ngClass]="{
                                'active-border': phone?.touched && phone.invalid
                              }" />
            <div *ngIf="phone?.touched && phone.invalid" class="error">

              <small *ngIf="phone.errors?.['required']">
                {{ 'ENTER_VALID_PHONE' | translate }}
              </small>
              <small *ngIf="registerForm.controls['phone']?.errors?.['pattern']">
                {{ 'ENTER_VALID_PHONE' | translate }}
              </small>
              <!-- 
              <small *ngIf="email.errors?.['email']">
                {{ 'EMAIL_INVALID' | translate }}
              </small> -->


            </div>


          </label>



          <label *ngIf="false">
            <small class="remember-me"> Promo code (Optional)

            </small>
            <input name="promocode" type="text" placeholder="Enter Promocode" [(ngModel)]="register.promocode" />

          </label>

          <div class="terms-conditions-box">
            <span class="terms-conditions">
              <input type="checkbox" class="m_r_10" [(ngModel)]="register.termsAccepted" name="terms" required />

              <span class="terms-conditions-wrapper">
                {{ 'I_AGREE_WITH' | translate }}

                <strong class="m_r_5 m_l_5" (click)="onCloseLogin()" routerLink="/terms-and-conditions">
                  {{ 'TERMS_CONDITIONS' | translate }}
                </strong>

                {{ 'AND' | translate }}

                <strong class="m_r_5 m_l_5" (click)="onCloseLogin()" routerLink="/privacypolicy">
                  {{ 'PRIVACY_POLICY' | translate }}
                </strong>
              </span>
            </span>

            <div *ngIf="registerForm.submitted && !register.termsAccepted" class="error">
              <small>{{ 'TERMS_REQUIRED' | translate }}</small>
            </div>
          </div>




          <button type="submit" class="submit-btn m_b_20" [disabled]="registerForm.invalid || !register.termsAccepted">

            <span *ngIf="!smallLoader"> {{'JOIN_US' | translate}}</span>
            <div class="loadergif" *ngIf="smallLoader">
              <div class="spin">◌</div>
            </div>
          </button>

        </form>

        <!-- Login Form -->
        <form #loginForm="ngForm" class="login-form m_t_20" *ngIf="FormOpenStr === 'LOGIN'"
          (ngSubmit)="onSubmitLogin(loginForm)">
          <label>
            {{'USERNAME' | translate}}*
            <input name="username" [placeholder]="'ENTER_USERNAME' | translate" [(ngModel)]="login.username" required
              minlength="4" maxlength="15" pattern="^[a-zA-Z0-9]+$"
              (input)="loginForm.controls['username'].markAsTouched()" (keypress)="preventSpace($event)" />
            <div *ngIf="
                            loginForm.controls['username']?.touched &&
                            loginForm.controls['username'].invalid
                          " class="error">
              <small *ngIf="loginForm.controls['username']?.errors?.['required']">
                {{ 'USERNAME_REQUIRED' | translate }}
              </small>

              <small *ngIf="loginForm.controls['username']?.errors?.['minlength'] || 
                                        loginForm.controls['username']?.errors?.['maxlength']">
                {{ 'USERNAME_LENGTH' | translate }}
              </small>

              <small *ngIf="loginForm.controls['username']?.errors?.['pattern']">
                {{ 'USERNAME_PATTERN' | translate }}
              </small>
            </div>
          </label>

          <label class="password-field">
            {{'PASSWORD' | translate}}*
            <div class="password-wrapper">
              <input name="password" [type]="showPassword ? 'text' : 'password'"
                [placeholder]="'ENTER_PASSWORD' | translate" [(ngModel)]="login.password" required minlength="6"
                maxlength="15" pattern="^[^\s]+$" (input)="loginForm.controls['password'].markAsTouched()"
                (keypress)="preventSpace($event)" />
              <span class="toggle-eye" (click)="togglePassword()">
                <i [class]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
              </span>
            </div>
            <div *ngIf="
                            loginForm.controls['password']?.touched &&
                            loginForm.controls['password']?.invalid
                          " class="error">
              <small *ngIf="loginForm.controls['password']?.errors?.['required']">
                {{ 'PASSWORD_REQUIRED' | translate }}
              </small>

              <small *ngIf="loginForm.controls['password']?.errors?.['minlength'] || 
                                loginForm.controls['password']?.errors?.['maxlength']">
                {{ 'PASSWORD_LENGTH' | translate }}
              </small>

              <small *ngIf="loginForm.controls['password']?.errors?.['pattern']">
                {{ 'PASSWORD_NO_SPACES' | translate }}
              </small>
            </div>
          </label>


          <div class="remember-me">
            <span>
              <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" /> {{'REMEMBER_ME' | translate}}
            </span>
            <strong (click)="onEnableLoginState('FORGOTPASSWORD')">{{"FORGOT_PASSWORD" | translate}}</strong>
          </div>

          <button type="submit" class="submit-btn m_b_0" [disabled]="loginForm.invalid">
            <span *ngIf="!smallLoader">{{'LOGIN' | translate}}</span>
            <span *ngIf="smallLoader" class="loading-icon">
              <div class="spin">◌</div>
            </span>
          </button>

        </form>
        <!-- Forgot Password -->
        <div class="form-area" *ngIf="FormOpenStr === 'FORGOTPASSWORD'">
          <app-forgot-password></app-forgot-password>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Login Area End -->